import React from 'react';
import { connect } from "react-redux";
import { checkAuthAction } from "../store/auth/action";
//import Layout from "../components/layout/layout";
import { Router, Route, Switch } from "react-router-dom";
import NonSubscriberLoginContainer from "../containers/NonSubscriberLoginContainer";
import { Container } from 'react-bootstrap';
import HeaderContainer from '../containers/HeaderContainer';
import FooterContainer from '../containers/FooterContainer';
import SearchArticleContainer from "../containers/troubleShooting/search/SearchArticleContainer";
import ArticleDetailContainer from "../containers/troubleShooting/articleDetails/ArticleDetailsContainer";
import ArticleListContainer from "../containers/troubleShooting/search/ArticleListContainer";
import QAListContainer from "../containers/connectint/QAListContainer";
import ErrorContainer from "../containers/ErrorContainer";
import NonLoginErrorComponent from '../components/errors/NonLoginErrorComponent';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga4';
import { config, trackingId } from "../config";

const history = createBrowserHistory();

ReactGA.initialize(trackingId);

// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.send({hitType: 'pageview', page: location.pathname}); // Record a pageview for the given page GA4
});

class MainLayoutContainer extends React.Component {

  constructor(props) {
    super(props);
    this.UnAuthenticatedURL = [
      "relogin",
      "error"
    ]
    this.currentPath = window.location.pathname;
    this.currentPath = this.currentPath.slice(1);    
    
  }
  /**
   * @method componentDidMount
   * to load the data after state changed
   */
  componentDidMount() {
    if (this.UnAuthenticatedURL.includes(this.currentPath) === false) {
      this.props.checkAuth();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authData.auth !== this.props.authData.auth && this.props.authData.auth.userId) {
      ReactGA.set({
        // any data that is relevant to the user session
        // that you would like to track with google analytics
        userId: this.props.authData.auth.userId  // user_id
      })

      ReactGA.send(window.location.pathname);
    }
  }

  render() {
    return (
      <Router history={history}>

          
        
          {this.props.authData.auth && this.props.authData.auth.message ?

            this.props.authData.auth.message === "success" ?
              <>
                <HeaderContainer className="App-header" />
                <Container className='mainContainer'>
                  <div className="content" ontouchstart="">
                  <Switch>
                    <Route exact path="/" component={SearchArticleContainer} />
                    <Route exact path="/troublesht" component={SearchArticleContainer} />
                    <Route exact path="/troublesht/articles" component={ArticleListContainer} />
                    <Route exact path="/troublesht/article/:articleID" component={ArticleDetailContainer} />
                    <Route exact path="/connectint/:searchKey?" component={QAListContainer} />
                    <Route exact path="/error" component={ErrorContainer} /> 
                    <Route exact path="*" component={ErrorContainer} /> 
                  </Switch>
                  </div>
                </Container>
                <FooterContainer />
              </>
              : <Route path='*' component={() => { window.location = config.loginURL + "?redirect=true&redirect_url=" + this.currentPath; return null; }} />
            : <> 
              
                  <Route  path="/api/" component={NonLoginErrorComponent} /> 
                  <Route exact path="/error" component={NonLoginErrorComponent} /> 
                  <Route exact path="/relogin" component={NonSubscriberLoginContainer} />
                 
              </> 
          }

        
        
      </Router>
    )
  }

}
//export default HeaderContainer;

/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  checkAuth: checkAuthAction,
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  authData: state.auth
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainLayoutContainer);